import { cn } from "@/lib/utils";

// Fictional sample values. The real scorecard is generated per assessment.
// Bar widths are static utility classes because Tailwind can't build class
// names from runtime values.
const SAMPLE_SCORES: { label: string; value: number; barWidth: string }[] = [
  { label: "Business model", value: 72, barWidth: "w-[72%]" },
  { label: "Operating model", value: 64, barWidth: "w-[64%]" },
  { label: "Structural protectors", value: 41, barWidth: "w-[41%]" },
];

export function ReportPreview() {
  return (
    <section
      aria-label="Sample report preview"
      className="bg-accent-light/40 my-10 rounded-2xl p-6"
    >
      <div className="border-border bg-card rounded-xl border px-7 py-6">
        <div className="mb-5 flex flex-wrap items-center justify-between gap-2.5">
          <p className="text-muted text-[11px] font-bold tracking-[0.07em] uppercase">
            Sample report · Mid-market logistics company
          </p>
          <span className="text-accent bg-accent-light rounded-full px-3 py-1 text-xs font-bold">
            Workflow Redesign
          </span>
        </div>
        <div className="grid items-center gap-5 sm:grid-cols-[220px_1fr] sm:gap-x-10">
          <div>
            <p className="text-primary text-5xl font-medium tracking-tight tabular-nums">
              68<span className="text-muted text-xl font-normal"> /100</span>
            </p>
            <p className="text-primary mt-2 text-[15px] font-semibold">Elevated exposure</p>
            <p className="text-muted mt-0.5 text-[13px]">High confidence · expert-reviewed</p>
          </div>
          <div className="flex flex-col gap-3.5">
            {SAMPLE_SCORES.map(({ label, value, barWidth }) => (
              <div key={label}>
                <div className="mb-1.5 flex justify-between text-sm">
                  <span className="text-primary font-medium">{label}</span>
                  <span className="text-muted-foreground tabular-nums">{value}</span>
                </div>
                <div className="bg-border/50 h-2 overflow-hidden rounded-full">
                  <div className={cn("bg-accent h-full rounded-full", barWidth)} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="text-muted-foreground mt-3.5 text-xs">
        Illustrative sample. Your scores are generated from your diagnostic answers.
      </p>
    </section>
  );
}
